import { Page } from "../../../core/internal/page/Page"
import { PageEventTracker } from "../../../core/internal/page/PageEventTracker"
import { PageListener } from "../../../index.browser"
import { HackleAppInvocationProcessor } from "../invocator/HackleAppInvocationProcessor"
import { TrackInvocation } from "../invocator/Invocation"
import BrowserPropertyProvider from "../../property/BrowserPropertyProvider"

export default class HackleAppPageListener implements PageListener {
  constructor(
    private readonly invocationProcessor: HackleAppInvocationProcessor,
    private readonly browserPropertyProvider: BrowserPropertyProvider
  ) {}

  onPageStarted(page: Page, _timestamp: number): void {
    this.track(page, _timestamp)
  }

  onPageEnded(_page: Page, _timestamp: number): void {
    // do nothing
  }

  private track(page: Page, _timestamp: number): void {
    try {
      const event = {
        key: PageEventTracker.PAGE_VIEW_EVENT_KEY,
        properties: {
          ...page.properties,
          [PageEventTracker.PAGE_NAME_PROPERTY_KEY]: page.pageName
        }
      }

      const invocation: TrackInvocation = {
        command: "track",
        parameters: {
          event,

          /**
           * @description use app side user instead of web side user.
           */
          user: undefined
        },
        browserProperties: this.browserPropertyProvider.getBrowserProperties(page)
      }

      this.invocationProcessor.processAsync(invocation)
    } catch {}
  }
}
